<template>
    <div class="amounts">
        <div
            class="amounts__extra-person-rate text-warning"
            v-if="
                isEditable &&
                techReservation.property.is_per_person_rates &&
                techReservation.rate.extra_person_rate
            "
        >
            {{ techReservationExtraPersonRateAmount }}
            per person per night charges incurred after
            {{ techReservation.rate.extra_person_base }} guests.<br />
            <span v-if="techReservation.property.is_children_rates"
                >Children included.</span
            >
            <span v-else>Children excluded.</span>
        </div>
        <div v-if="techReservation.total.extra_guest_fee > 0">
            <div class="amounts__item extra-guest-fee-item" @click="showPartials=!showPartials">
                <div class="amounts__item__label">Subtotal</div>
                <div class="amounts__item__amount extra-guest-fee-amount">
                    {{ techReservationNetAmount }}
                </div>
            </div>
            <div class="amounts__item sub-item" v-if="showPartials">
                <div class="amounts__item__label">Rental Charges</div>
                <div class="amounts__item__amount">
                    {{ techReservationRentalChargesAmount }}
                </div>
            </div>
            <div class="amounts__item sub-item" v-if="showPartials">
                <div class="amounts__item__label">Extra Guests</div>
                <div class="amounts__item__amount">
                    {{ techReservationExtraGuestFeeAmount }}
                </div>
            </div>
        </div>
        <div v-else class="amounts__item">
            <div class="amounts__item__label">Subtotal</div>
            <div class="amounts__item__amount">
                {{ techReservationNetAmount }}
            </div>
        </div>
        <div
            v-if="techReservation.total.services * 1 !== 0"
            class="amounts__item"
        >
            <div class="amounts__item__label">Services</div>
            <div class="amounts__item__amount">
                {{ techReservationServicesAmount }}
            </div>
        </div>
        <div class="amounts__item">
            <div class="amounts__item__label">Taxes</div>
            <div class="amounts__item__amount">
                {{ techReservationTaxesAmount }}
            </div>
        </div>
        <div class="amounts__item">
            <div class="amounts__item__label">Fees</div>
            <div class="amounts__item__amount">
                {{ techReservationFeesAmount }}
            </div>
        </div>
        <div
            v-if="techReservation.total.discount * 1 > 0"
            class="amounts__item"
        >
            <div class="amounts__item__label">Discount</div>
            <div class="amounts__item__amount">
                -{{ techReservationDiscountAmount }}
            </div>
        </div>
        <div
            v-if="techReservation.total.deposits * 1 > 0"
            class="amounts__item"
        >
            <div class="amounts__item__label">
                {{ website.other_deposit_label }}
            </div>
            <div class="amounts__item__amount">
                {{ techReservationDepositsAmount }}
            </div>
        </div>
        <hr />
        <div class="amounts__item">
            <div class="amounts__item__label"></div>
            <div class="amounts__item__amount_total">
                {{ techReservationTotalAmount }}
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { toAmountDisplay } from '../../../../utils/numbers';

export default {
    props: {
        techReservation: {
            type: Object,
            required: true,
        },
        currency: {
            type: Object,
            required: true,
        },
        isEditable: {
            type: Boolean,
            default: false,
        }
    },
    data() {
        return {
            showPartials: false,
        };
    },
    computed: {
        techReservationExtraPersonRateAmount() {
            return toAmountDisplay({
                amount: this.techReservation.rate.extra_person_rate,
                currency: this.currency.symbol,
            });
        },
        techReservationNetAmount() {
            return toAmountDisplay({
                amount: this.techReservation.total.reservation_net,
                currency: this.currency.symbol,
            });
        },
        techReservationRentalChargesAmount() {
            return toAmountDisplay({
                amount: this.techReservation.total.reservation_net - this.techReservation.total.extra_guest_fee,
                currency: this.currency.symbol,
            });
        },
        techReservationExtraGuestFeeAmount() {
            return toAmountDisplay({
                amount: this.techReservation.total.extra_guest_fee,
                currency: this.currency.symbol,
            });
        },
        techReservationDiscountAmount() {
            return toAmountDisplay({
                amount: this.techReservation.total.discount,
                currency: this.currency.symbol,
            });
        },
        techReservationDepositsAmount() {
            return toAmountDisplay({
                amount: this.techReservation.total.deposits,
                currency: this.currency.symbol,
            });
        },
        techReservationFeesAmount() {
            return toAmountDisplay({
                amount: this.techReservation.total.fees_net,
                currency: this.currency.symbol,
            });
        },
        techReservationTaxesAmount() {
            return toAmountDisplay({
                amount: this.techReservation.total.taxes,
                currency: this.currency.symbol,
            });
        },
        techReservationServicesAmount() {
            return toAmountDisplay({
                amount: this.techReservation.total.services,
                currency: this.currency.symbol,
            });
        },
        techReservationTotalAmount() {
            return toAmountDisplay({
                amount: this.techReservation.total.gross,
                currency: this.currency.symbol,
            });
        },
        ...mapGetters('onlineBooking', ['website']),
    },
};
</script>

<style lang="scss" scoped>
.amounts {
    &__extra-person-rate {
        margin-bottom: 1rem;
    }

    &__item {
        display: flex;
        justify-content: space-between;

        &.sub-item {
            font-size: 11px;
            color: gray;
            margin-left: 6px;
        }

        &.extra-guest-fee-item:hover {
            cursor: pointer;

            .extra-guest-fee-amount {
                color: #0d47a1;
            }
        }

        &__amount {
            &.extra-guest-fee-amount {
                text-decoration: underline;
            }
        }

        &__amount_total {
            font-size: 16px;
            font-weight: bold;
        }
    }
}
</style>
